import React, {Component} from 'react';

import Option from './option.js';

export default class Options extends Component {

  constructor(props) {
    super(props);
    this.handleAddNewOption = this.handleAddNewOption.bind(this);
  }

  handleAddNewOption() {
    this.props.addNewDropDownOption(this.props.customisationIndex);
  }

  renderOptions() {
    return(
      this.props.options.map(option => (
        <li key={option.index}>
          <Option
            customisationIndex={this.props.customisationIndex}
            option={option}
            deleteDropDownOption={this.props.deleteDropDownOption}
            changeOptionValue={this.props.changeOptionValue}
            changeOptionPrice={this.props.changeOptionPrice}
          />
        </li>
      ))
    );
  }

  renderAddButton() {
    return (
      this.props.options.length < 20 ?
        <button className="Options__add" onClick={this.handleAddNewOption}>
          Add new option
        </button> :
        <button className="Options__add" disabled>
          Add new option
        </button>
    );
  }

  render() {
    return(
      <section className="Options">
        <h3>Drop down options:</h3>
        <p className="hint">
          You can add up to 20 options. Prices are optional.
          &nbsp;
          {this.props.helpLinks.linkFor('options')}
        </p>
        <ul>
          {this.renderOptions()}
        </ul>
        <div className="ui-options">
          {this.renderAddButton()}
        </div>
      </section>
    );
  }
  
};



// WEBPACK FOOTER //
// ./src/app/item-customisations/fields/drop-down/options.js